import React from 'react';
import { MaintenanceContextType } from '../typings/maintenance-app';

export const MaintenanceContext =
  React.createContext<MaintenanceContextType | null>(null);

export function useMaintenanceContext(): MaintenanceContextType {
  const maintenanceContext = React.useContext(MaintenanceContext);

  if (!maintenanceContext) {
    throw new Error('No maintenance context value was provided.');
  }

  return maintenanceContext;
}
